// Google G — PLACEHOLDER per designer notes. Swap for the official Google G
// SVG before production. Sourced from for-engineering-auth/assets/sso-google.svg.

import type { SVGProps } from 'react';

export function SsoGoogleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      role="img"
      aria-label="Google"
      {...props}
    >
      <circle cx="7" cy="7" r="6" fill="none" stroke="#4285F4" strokeWidth="2" />
      <path d="M7 7 L13 7 L13 13 Z" fill="#34A853" />
      <path d="M7 7 L1 7 L1 1 Z" fill="#FBBC05" />
      <path d="M7 7 L7 13 L1 13 Z" fill="#EA4335" />
    </svg>
  );
}
